import React, { useState } from "react";
import './WhoAreYou.css';
import cyberpunk from '../../assets/cyberpunk.png';

const WhoAreYou = () => {
  const [curElement, setCurElement] = useState('');

  const onClickCard = (id) => {
    if (id == curElement) {
      const card = document.getElementById(String(id))
      card.childNodes[1].style.display="none";
      card.childNodes[0].style.fontWeight="400";
      if (window.innerWidth > 1199)
        card.style.width=`90%`;
    } 

    else if (curElement != '') {
      let card = document.getElementById(curElement)
      card.childNodes[1].style.display="none";
      card.childNodes[0].style.fontWeight="400";
      if (window.innerWidth > 1199)
        card.style.width=`90%`;

      // setting new element
      card = document.getElementById(String(id))
      card.childNodes[1].style.display="block";
      card.childNodes[0].style.fontWeight="800";
      card.style.width=`100%`;
      setCurElement(id);
    }

    else if (curElement == '') {
      const card = document.getElementById(String(id))
      card.childNodes[1].style.display="block";
      card.childNodes[0].style.fontWeight="800";
      card.style.width=`100%`;
      setCurElement(id);
    }
    
  }

  return (
    <div className="whoareyou-container container">
      <p className="whoareyou-heading">Who are you?</p>
      <div className="row gy-3 justify-content-center">
        <div className="col-xl-4 col-lg-5 col-md-12 col-sm-12 col-12 first-col">
          <div className="whoareyou-cards" id='card1' onClick={(e) => onClickCard(e.currentTarget.id)}>
            <p className="whoareyoucards-title">community</p>
            <div className="hidden">
              <p className="whoareyoucards-subtitle">Engaging with your community should not be boring!</p>
              <p className="whoareyoucards-description">
              Build a strong culture with real-like engagement & shared experiences in your community’s social adda.
              </p>
            </div>
          </div>
          <div className="whoareyou-cards" id='card2' onClick={(e) => onClickCard(e.currentTarget.id)}>
            <p className="whoareyoucards-title">office</p>
            <div className="hidden">
              <p className="whoareyoucards-subtitle">Remote work shouldn’t be isolating!</p>
              <p className="whoareyoucards-description">
              Connect your distributed team with an inviting office space for meetings and happy hours.
              </p>
            </div>
          </div>
          <div className="whoareyou-cards" id='card3' onClick={(e) => onClickCard(e.currentTarget.id)}>
            <p className="whoareyoucards-title">ed-tech</p>
            <div className="hidden">
              <p className="whoareyoucards-subtitle">Learning shouldn’t feel like a punishment!</p>
              <p className="whoareyoucards-description">
              Host your classrooms with learning activities & engagement as good as being in a real-like campus set-up.
              </p>
            </div>
          </div>
          <div className="whoareyou-cards" id='card4' onClick={(e) => onClickCard(e.currentTarget.id)}>
            <p className="whoareyoucards-title">event organiser</p>
            <div className="hidden">
              <p className="whoareyoucards-subtitle">Hosting events shouldn’t be lifeless zoom webinars!</p>
              <p className="whoareyoucards-description">
              Connect your distributed team with an inviting office space for meetings and happy hours.
              </p>
            </div>
          </div>
        </div>
        <div className="col-xl-7 col-lg-7 col-md-12 col-sm-12 col-12 imgcol">
          <img src={cyberpunk} alt="cyberpunk" width="85%" className="whoareyou-img"/>
          <br />
          <button className="whoareyou-btn ">get started >>></button>
        </div>
      </div>
    </div>
  );
}

export default WhoAreYou;